var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.showKaiAnswersBottomBar)?_c('InnerBottomBar',{attrs:{"id":"bottombar"}}):_vm._e(),(_vm.showKaiAnswersBottomBar)?_c('KaiAnswersBottomBar',{attrs:{"id":"kai-answers-bottombar"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }